module.exports = __webpack_public_path__ + "static/media/Color.78d9e77d.jpeg";